export default __webpack_public_path__ + "static/media/chart.ca33e086.png";